<template>
  <el-row style="height: 670px;width: 100%;margin-top: 80px;">
    <el-row style="width: 100%;height: 100px;">
      <el-row class="software-logo" />
    </el-row>
    <el-row style="width: 100%;height: 570px;">
      <el-col style="width: 50%;height: 484px;margin-top: 86px;display: flex;flex-direction: column;align-items: flex-end;">
        <el-row style="width: 660px;margin-right: 30px;height: 100%;border: 2px solid #dddddd;border-radius: 20px;display: flex;flex-direction: column;align-items: center;">
          <el-row style="font-size: 32px;height: 80px;line-height: 80px;font-weight: bold;color: #00bf86;width: 100%;">{{dataList[0].name}}</el-row>
          <el-row style="background-color: #00bf86;width: 80%;height: 2px;" />
          <el-row @click.native="changeRoute('/software', dataList[0].id)" class="software-img" :style="{'background-image': 'url(' + dataList[0].img + ')'}"></el-row>
        </el-row>
      </el-col>
      <el-col style="width: 50%;height: 484px;margin-top: 86px;display: flex;flex-direction: column;align-items: flex-start;">
        <el-row style="width: 660px;margin-left: 30px;height: 100%;border: 2px solid #dddddd;border-radius: 20px;display: flex;flex-direction: column;align-items: center;">
          <el-row style="font-size: 32px;height: 80px;line-height: 80px;font-weight: bold;color: #00bf86;width: 100%;">{{dataList[1].name}}</el-row>
          <el-row style="background-color: #00bf86;width: 80%;height: 2px;" />
          <el-row @click.native="changeRoute('/software', dataList[1].id)" class="software-img" :style="{'background-image': 'url(' + dataList[1].img + ')'}"></el-row>
        </el-row>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: 'Software',
  data() {
    return {
      dataList: [
        {id: '311', name: '综合能源监测系统', img: require('../../assets/software1.jpg')},
        {id: '312', name: '分布式光伏运维系统', img: require('../../assets/software2.jpg')}
      ],
      sel: 0,
      data: ''
    }
  },
  methods: {
    overCircle(i) {
      this.sel = i
    },
    changeRoute(path, page) {
      this.$router.push({path: path, query: {page: page}})
    }
  }
}
</script>

<style scoped>
  .software-logo {
    background: url("../../assets/software.png") no-repeat;
    width: 470px;
    margin-left: calc(50% - 235px);
    height: 100px;
    cursor: pointer;
  }
  .circle-class {
    width: 80px;
    height: 80px;
    border-radius: 40px;
    margin-left: 10px;
    cursor: pointer;
    background-color: #ffffff;
    color: #00bf86;
    border: 2px solid #00bf86;
  }
  .circle-class:hover {
    background-color: #00bf86;
    color: #ffffff;
    border: 2px solid #ffffff;
  }
  .normal-icon {
    font-size: 56px;
    line-height: 80px;
  }
  .big-icon {
    font-size: 44px;
    color: #00bf86;
    line-height: 80px;
  }
  .big-icon:hover {
    color: #ffffff;
  }
  .software-img {
    width: 517px;
    height: 272px;
    cursor: pointer;
    margin-top: 46px;
    background-repeat: no-repeat
  }
</style>



// WEBPACK FOOTER //
// src/components/home/Software.vue